export default "__VITE_ASSET__xRPKjDJ8__"